import { useCreateWorkOrderCommission } from '@/core/domain/workorder/WorkOrdersCommisions/WorkOrdersCommissions.hooks';
import {
  CreateWorkOrderCommissionRequest,
  WorkOrderCommission,
} from '@/core/domain/workorder/WorkOrdersCommisions/WorkOrdersCommissions.types';
import { WorkOrderItem } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import { Form, Modal, ModalProps } from 'antd';
import { useEffect } from 'react';
import { useWorkorderDetailContext } from '../../../WorkorderDetailProvider';
import CommisionForm from '../CommisionForm';

type Props = Omit<ModalProps, 'onCancel'> & {
  item?: WorkOrderItem;
  onCancel?: VoidFunction;
  maxQuantity: number;
  employeesSelected: WorkOrderCommission[];
};

const CommissionCreateModalForm: React.FC<Props> = ({
  item,
  maxQuantity,
  employeesSelected,
  ...props
}) => {
  const [form] = Form.useForm<CreateWorkOrderCommissionRequest>();
  const quantityField = Form.useWatch('quantity', form);

  function getBaseValue() {
    const subTotal = (item?.unitPrice || 0) * (item?.quantity || 0);
    const totalValue = subTotal - subTotal * (item?.discount || 0);
    return totalValue;
  }

  const {
    complement: { data: complement },
  } = useWorkorderDetailContext();

  useEffect(() => {
    form.setFieldValue('baseValue', getBaseValue() || 0);
    form.setFieldValue('quantity', maxQuantity || 0);
  }, [item, maxQuantity]);

  useEffect(() => {
    form.setFieldValue('baseValue', getBaseValue() || 0);
  }, [quantityField]);

  const createCommission = useCreateWorkOrderCommission();

  async function handleSubmit() {
    try {
      const values = await form.validateFields();

      if (complement && item?.id) {
        await createCommission.mutateAsync({
          ...values,
          complementId: complement.id,
          percent: values.percent,
          itemId: item.id,
        });

        if (props.onCancel) {
          props.onCancel();
        }
      }
    } catch {}
  }

  return (
    <Modal
      {...props}
      title="Adicionar comissão"
      onOk={handleSubmit}
      okText="Salvar"
      confirmLoading={createCommission.isLoading}
      destroyOnClose
    >
      <CommisionForm
        form={form}
        itemType={item?.type}
        baseValue={getBaseValue() || 0}
        maxQuantity={maxQuantity}
        employeesSelected={employeesSelected}
        employeeId={item?.employee?.id}
        itemId={item?.itemId}
      />
    </Modal>
  );
};

export default CommissionCreateModalForm;
